export const shapesContinents = [
    {
        category: 'Continents',
        key: 'continent_africa',
        name: 'Africa',
        icon: '🌍',
        path: "/shapes/continent_africa.png"
    },
    {
        category: 'Continents',
        key: 'continent_antarctica',
        name: 'Antarctica',
        icon: '🐧',
        path: "/shapes/continent_antarctica.png"
    },
    {
        category: 'Continents',
        key: 'continent_asia',
        name: 'Asia',
        icon: '🐉',
        path: "/shapes/continent_asia.png"
    },
    {
        category: 'Continents',
        key: 'continent_australia',
        name: 'Australia',
        icon: '🦘',
        path: "/shapes/continent_australia.png"
    },
    {
        category: 'Continents',
        key: 'continent_europe',
        name: 'Europe',
        icon: '🏰',
        path: "/shapes/continent_europe.png"
    },
    {
        category: 'Continents',
        key: 'continent_north_america',
        name: 'North America',
        icon: '🦬',
        path: "/shapes/continent_north_america.png"
    },
    {
        category: 'Continents',
        key: 'continent_south_america',
        name: 'South America',
        icon: '🦙',
        path: "/shapes/continent_south_america.png"
    }
];
